import { constants } from '@bingads-webui-campaign-react/image-experience-model';
import { FolderAssetType } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import {
  oDataTypeConfig,
  namePropertyConfig,
} from './request-transformer-util';

const removeEncodingPrefix = (fileData) => {
  const base64 = 'base64,';
  const base64Index = fileData.indexOf(base64);

  return base64Index > -1
    ? fileData.substr(base64Index + base64.length)
    : fileData;
};

export const transformAddUploadAssetRequest = ({
  blobName, // for video
  data, // for image
  name,
}, folderAssetType) => {
  const model = {
    '@odata.type': oDataTypeConfig[folderAssetType],
    [namePropertyConfig[folderAssetType]]: name,
    SourceType: constants.sourceTypes.UserUploaded,
  };

  if (folderAssetType === FolderAssetType.Video) {
    model.OriginalIdentifier = blobName;
  } else {
    model.Data = removeEncodingPrefix(data);
    model.Type = 'GenericImage';
  }

  return model;
};

export const transformAddStockImageRequest = ({ stockImageId, imageType = 'GenericImage' }) => ({
  '@odata.type': oDataTypeConfig[FolderAssetType.Image],
  StockImageId: stockImageId,
  StockImageVendor: 'ShutterStock',
  Type: imageType,
});

export const transformAddInvestImageRequest = ({ investImageId, imageSrc, imageType = 'GenericImage' }) => ({
  '@odata.type': oDataTypeConfig[FolderAssetType.Image],
  XandrAssetId: investImageId,
  Url: imageSrc,
  SourceType: 'XandrImported',
  Type: imageType,
});

export const transformAddInvestVideoRequest = ({
  investVideoId, videoSrc, description,
}) => ({
  '@odata.type': oDataTypeConfig[FolderAssetType.Video],
  XandrAssetId: investVideoId,
  Url: videoSrc,
  Description: description,
  SourceType: 'XandrImported',
});

export const transformAddUrlImageRequest = ({ imageSrc, imageType = 'GenericImage', sourceType }) => ({
  '@odata.type': oDataTypeConfig[FolderAssetType.Image],
  Url: imageSrc,
  Type: imageType,
  SourceType: sourceType,
});

export const transformAddImageWithBaseIdRequest = ({
  imageSrc, metaData, baseId, sourceType,
}) => ({
  '@odata.type': oDataTypeConfig[FolderAssetType.Image],
  Url: imageSrc,
  Type: 'GenericImage',
  BaseId: baseId,
  Metadata: metaData,
  ...(sourceType ? { sourceType } : {}),
});

export const transformAddUrlVideoRequest = ({ videoUrl, name }) => ({
  '@odata.type': oDataTypeConfig[FolderAssetType.Video],
  Url: videoUrl,
  Description: name,
  SourceType: constants.sourceTypes.WebsiteImported,
});
